import React, { useEffect } from "react";
import ChooseType from "./ChooseType";
import Card from "./Card";
import useGetPaymentList from "../../../Global/Api/Account/getPaymentListApi";
import { useDispatch, useSelector } from "react-redux";
import { setPaymentModal } from "../../../Store/Slice/techsbookSlice";
import {setSendData} from "../../../Store/Slice/scheduleSlice";
import {useParams} from "react-router-dom";
import useCredits from "../../../Global/Api/Settings/credits.api";

export default function Cards({type, setType, jobDatetime, withCredits = true}) {
  const {title: jobTitle} = useParams();
  const dispatch = useDispatch();
  const getPaymentList = useGetPaymentList();
  const { credits, get: getCredits } = useCredits();
  const { paymentList } = useSelector((state) => state.rootReducer.techsbookSlice);
  const scheduleStep = useSelector((state) => state.rootReducer.scheduleSlice.schedule_step);
  const accountData = useSelector((state) => state.rootReducer.techsbookSlice.userData);
  const creditValue = useSelector((state) => state.rootReducer.scheduleSlice.sendData.credit_to_use);

  useEffect(() => {
    if (jobTitle && scheduleStep === 4) {
      dispatch(setSendData({ payment_method_id: paymentList[0]?.id }));
      dispatch(setSendData({ payment_brand: paymentList[0]?.payment_method_data?.brand ?? paymentList[0]?.brand }));
    }
  }, [jobTitle, scheduleStep])

  useEffect(() => {
    getPaymentList.get();
    getCredits();
  }, []);

  return (
    <div className="payment__cards">
      <ChooseType jobDatetime={jobDatetime} type={type} setType={setType}/>
      {type ? (
        <>
          <div className="payment__cards-list">
            {paymentList?.length > 0 && paymentList?.map((item) => <Card key={item?.id} item={item} paymentList={paymentList}/>)}
          </div>
          <div
            onClick={() => {
              dispatch(setPaymentModal(true));
            }}
            className="payment__cards-add"
          >
            <img src="/assets/icons/blue-plus.svg" alt="svg"/>
            <span>Add new card</span>
          </div>
          {withCredits && <div className="payment__cards-credits">
              <div className="payment__cards-credits_top">
                  <img src="/assets/images/credits.svg" alt=""/>
                  <p>
                      <span>Available Tokens</span><br/>
                      <span className='credit-amount'>{accountData?.country_currency_sign + '' + credits?.credits}</span>
                  </p>
              </div>
              <div className="payment__cards-credits_bot">
                  <p>How many tokens would you like to apply?</p>
                  <div className="input">
                      <p style={{
                          color: '#8D8D9D',
                          marginRight: '4px',
                      }}>$</p>
                      <input
                          placeholder="0"
                          value={creditValue}
                          onChange={(e) => {
                              const value = Number(e.target.value);
                              const maxCredits = credits?.credits || 0;
                              const clampedValue = Math.min(Math.max(value, 0), maxCredits);
                              dispatch(setSendData({ credit_to_use: clampedValue }));
                          }}
                      />
                  </div>
              </div>
          </div>}
        </>
      ) : (
        <div className='payment__affirm'>
          <div>
            <img src="/assets/images/affirm-empty.svg" alt=""/>
          </div>
          <p className="payment__affirm-text">Once you have placed a job, you will need to complete the Affirm
            confirmation form on the job details page to finalize your payment.</p>
        </div>
      )}
    </div>
  );
}
